import api from "../axios";

export interface Feedback {
  question: string;
  answer: string;
}

export interface FeedbackData {
  service_id: string;
  service_type: "auto" | "jam";
}

export interface FeedbackPayload {
  feedback: Feedback[];
  data: FeedbackData;
}

export class ApiFeedbacks {
  sendFeedbacks(payload: FeedbackPayload) {
    return api.post("/feedbacks", payload);
  }
}
